module.exports = __webpack_public_path__ + "static/equipment-jeep-d43632de74f80974b3e29935f9850bb0.jpg";